import { getSeoInfo } from '@/api'

// SEO配置缓存
let seoCache = null

/**
 * 获取SEO配置
 */
export async function fetchSeoConfig() {
  if (seoCache) {
    return seoCache
  }
  
  try {
    const res = await getSeoInfo({})
    if (res.code === 200 || res.code === 0) {
      seoCache = res.data || {}
      return seoCache
    }
  } catch (error) {
    console.error('获取SEO配置失败:', error)
  }
  return {}
}

/**
 * 设置页面SEO信息
 * @param {Object} seoData - SEO数据对象 { title, keywords, description }
 */
export function setPageSEO(seoData) {
  if (!seoData) return
  
  // 设置标题
  if (seoData.title) {
    document.title = seoData.title
  }
  
  // 设置keywords
  let keywordsMeta = document.querySelector('meta[name="keywords"]')
  if (!keywordsMeta) {
    keywordsMeta = document.createElement('meta')
    keywordsMeta.name = 'keywords'
    document.head.appendChild(keywordsMeta)
  }
  if (seoData.keywords) {
    keywordsMeta.content = seoData.keywords
  }
  
  // 设置description
  let descriptionMeta = document.querySelector('meta[name="description"]')
  if (!descriptionMeta) {
    descriptionMeta = document.createElement('meta')
    descriptionMeta.name = 'description'
    document.head.appendChild(descriptionMeta)
  }
  if (seoData.description) {
    descriptionMeta.content = seoData.description
  }
}

/**
 * 根据路由名称获取对应的SEO配置
 * @param {String} routeName - 路由名称
 * @param {Object} seoConfig - SEO配置对象
 */
export function getRouteSEO(routeName, seoConfig) {
  const seoMap = {
    'Home': {
      title: seoConfig.indexTitle,
      keywords: seoConfig.indexKeywords,
      description: seoConfig.indexDescription
    },
    'About': {
      title: seoConfig.usTitle,
      keywords: seoConfig.usKeywords,
      description: seoConfig.usDescription
    },
    'Products': {
      title: seoConfig.productTitle,
      keywords: seoConfig.productKeywords,
      description: seoConfig.productDescription
    },
    'Services': {
      title: seoConfig.serverTitle,
      keywords: seoConfig.serverKeywords,
      description: seoConfig.serverDescription
    },
    'News': {
      title: seoConfig.newTitle,
      keywords: seoConfig.newKeywords,
      description: seoConfig.newDescription
    },
    'Hr': {
      title: seoConfig.hrTitle,
      keywords: seoConfig.hrKeywords,
      description: seoConfig.hrDescription
    },
    'Contact': {
      title: seoConfig.contactTitle,
      keywords: seoConfig.contactKeywords,
      description: seoConfig.contactDescription
    }
  }
  
  return seoMap[routeName] || {}
}
